import script from "./trayReadcode.vue?vue&type=script&setup=true&lang=js"
export * from "./trayReadcode.vue?vue&type=script&setup=true&lang=js"

import "./trayReadcode.vue?vue&type=style&index=0&id=48311fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48311fa6"]])

export default __exports__